import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { ReservationsDashboardTab } from '@/pages/reservations/reservations-dashboard'

import * as S from './reservations.styled'
import { ClientProfileReservationsProps } from './reservations.types'

export const Reservations = ({ clientId }: ClientProfileReservationsProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  return (
    <S.Container>
      <ReservationsDashboardTab
        resident={{ id: Number(clientId) }}
        building={clientData.buildingId}
      />
    </S.Container>
  )
}
